export const throwOnOperationErrors = (data) => {
  let foundKeyWithOperationInfoErrors = null;
  Object.keys(data).forEach((key) => {
    if (data[key]?.__typename === "OperationInfo") {
      foundKeyWithOperationInfoErrors = key;
      throw data[foundKeyWithOperationInfoErrors];
    }
  });
};
